// extracted by mini-css-extract-plugin
export var childrenContent = "bM_fx";
export var content = "bM_R";
export var titleContent = "bM_fy";
export var titleContentLabel = "bM_fz";